
import React, { useRef, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const BASE_URL = "https://ecom.cyberathon.com";
const API_URL = BASE_URL + "/index.php/Api/list_get_product";

const VerticalScroll = ({ dynamicHeight }) => {
  const scrollRef = useRef(null);
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  // useEffect(() => {
  //   axios.get(API_URL)
  //     .then(res => setProducts(res.data.products || []))
  //     .catch(err => console.error("API Error:", err));
  // }, []);
useEffect(() => {
  axios.get(API_URL)
    .then(res => {
      const onlyProducts = (res.data.products || []).filter(
        (item) => item.product_type === "product"
      );

      setProducts(onlyProducts);
    })
    .catch(err => console.error("API Error:", err));
}, []);

  // Auto-scroll
  useEffect(() => {
    const box = scrollRef.current;
    const speed = 1.2;

    const interval = setInterval(() => {
      if (box) {
        box.scrollTop += speed;

        if (box.scrollTop >= box.scrollHeight - box.clientHeight) {
          box.scrollTop = 0;
        }
      }
    }, 20);

    return () => clearInterval(interval);
  }, []);
const cleanDescription = (html) => {
  if (!html) return "";

  return html
    .replace(/<[^>]*>/g, " ")   // 🔥 saare HTML tags remove
    .replace(/\s+/g, " ")       // extra spaces clean
    .trim();
};
  return (
    <div className="col-md-4 py-1 px-5">
      <h3 className="text-center pb-3">All Products</h3>

      <div
        ref={scrollRef}
        className="overflow-hidden"
        style={{
          height: dynamicHeight ? `${dynamicHeight}px` : "400px",
          width: "100%",
        }}
      >
        {products.concat(products).map((p, index) => (
          <div key={index} className="card mb-4 shadow"
            style={{ width: "250px", margin: "auto", borderRadius: "10px" ,cursor:"pointer"}}
             onClick={() => navigate(`/DetailsSection3/${p.prod_id}`)}
            >
            

             <div className="position-relative">
            {/* <img
              src={`${BASE_URL}/${p.Product_image}`}
              className="card-img-top"
              style={{ height: "250px", objectFit: "cover" }}
            /> */}
            <img
  src={
    Array.isArray(p.Product_image)
      ? `${BASE_URL}/${p.Product_image[0]}`
      : `${BASE_URL}/${p.Product_image}`
  }
  alt={p.Product_name}
  className="card-img-top"
  style={{ height: "250px", objectFit: "cover" }}
/>

            <span className="badge bg-success position-absolute bottom-0 start-0 rounded-0">
            {p.discount}% off
          </span>
           </div>
           
        


             <div className="card-body text-start">
          <h6 className="card-title mb-1 fw-bold">{p.Product_name}</h6>
          {/* <small className="mb-1 d-block">{p.discription}</small> */}
    <small className="mb-1 d-block one-line-ellipsis">
  {cleanDescription(p.discription) || "\u00A0"}
</small>
          <div className="d-flex align-items-center justify-content-start gap-2 ">
            <p className="card-text fw-bold text-success mb-0">₹{p.current_price}</p>
            <small className="text-decoration-line-through text-muted"> ₹{p.old_price}</small>
          </div>
          </div>

          </div>
        ))}
      </div>
    </div>
  );
};

export default VerticalScroll;
